function i(r, s) {
  for (var e = -1, a = Array(r); ++e < r; )
    a[e] = s(e);
  return a;
}
var t = i;
export {
  t as _
};
